import { render, staticRenderFns } from "./FooterComponentEdunetin.vue?vue&type=template&id=a4727a16&scoped=true"
import script from "./FooterComponentEdunetin.vue?vue&type=script&lang=ts"
export * from "./FooterComponentEdunetin.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentEdunetin.vue?vue&type=style&index=0&id=a4727a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4727a16",
  null
  
)

export default component.exports